import React, { Component } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

class Developer extends Component {
	render() {
		return (
			<center>
				<div>
					<Navbar />

					<div className='container wrap '>
						<div className='row'>
							<center>
								<div className='col-sm-5 col-md-offset-3'>
									<div className='well well-sm'>
										<div className='row'>
											<div className='col-md-6 col-md-offset-3'>
												<img
													src={require('./images/person.png')}
													alt=''
													className='img-rounded img-responsive'
												/>
												<div>
													<h3 style={{ fontWeight: '600' }}>Adarsh Gautam</h3>
													<small>
														<h5 style={{ fontWeight: '800' }}>
															Up,India <i className='glyphicon glyphicon-map-marker' />
														</h5>
													</small>
													<p>
														<i
															style={{ fontWeight: '600' }}
															className='glyphicon glyphicon-envelope'
														/>gadarsh555@gmail.com
														<br />
														<br />
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</center>
						</div>
					</div>
					<Footer />
				</div>
			</center>
		);
	}
}

export default Developer;
